import { adminSupportQueryKeys as e } from "../supportQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { supportApi as r } from "@maat/api-main";
//#region src/support/admin/useAdminArticleMutations.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.adminCreateArticle(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.articles() });
		}
	});
}, a = () => {
	let i = n();
	return t({
		mutationFn: ({ id: e, payload: t }) => r.adminUpdateArticle(e, t),
		onSuccess: (t, { id: n }) => {
			i.invalidateQueries({ queryKey: e.articles() }), i.invalidateQueries({ queryKey: e.article(n) });
		}
	});
}, o = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.adminDeleteArticle(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.articles() });
		}
	});
};
//#endregion
export { i as useCreateAdminArticleMutation, o as useDeleteAdminArticleMutation, a as useUpdateAdminArticleMutation };
